function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 500 390"
}, props), React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M10 145c0-5.523 4.477-10 10-10h460c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10H20c-5.523 0-10-4.477-10-10v-90z",
  fill: "#fff"
})), React.createElement("rect", {
  x: "165",
  y: "165",
  width: "260",
  height: "25",
  rx: "5",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  x: "165",
  y: "200",
  width: "130",
  height: "15",
  rx: "2",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M40 175c0-5.523 4.477-10 10-10h40v50H50c-5.523 0-10-4.477-10-10v-30z",
  fill: "#FFE1D5"
}), React.createElement("path", {
  d: "M145 205c0 5.523-4.477 10-10 10H95v-50h40c5.523 0 10 4.477 10 10v30z",
  fill: "#2655BD"
}), React.createElement("g", {
  filter: "url(#filter1_d)"
}, React.createElement("path", {
  d: "M10 15c0-5.523 4.477-10 10-10h460c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10H20c-5.523 0-10-4.477-10-10V15z",
  fill: "#fff"
})), React.createElement("rect", {
  x: "165",
  y: "35",
  width: "260",
  height: "25",
  rx: "5",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  x: "165",
  y: "70",
  width: "130",
  height: "15",
  rx: "2",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M40 45c0-5.523 4.477-10 10-10h40v50H50c-5.523 0-10-4.477-10-10V45z",
  fill: "#62D493"
}), React.createElement("path", {
  d: "M145 75c0 5.523-4.477 10-10 10H95V35h40c5.523 0 10 4.477 10 10v30z",
  fill: "#DAF5E6"
}), React.createElement("g", {
  filter: "url(#filter2_d)"
}, React.createElement("path", {
  d: "M10 275c0-5.523 4.477-10 10-10h460c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10H20c-5.523 0-10-4.477-10-10v-90z",
  fill: "#fff"
})), React.createElement("rect", {
  x: "165",
  y: "295",
  width: "260",
  height: "25",
  rx: "5",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  x: "165",
  y: "330",
  width: "130",
  height: "15",
  rx: "2",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M40 305c0-5.523 4.477-10 10-10h40v50H50c-5.523 0-10-4.477-10-10v-30z",
  fill: "#FFC43E"
}), React.createElement("path", {
  d: "M145 335c0 5.523-4.477 10-10 10H95v-50h40c5.523 0 10 4.477 10 10v30z",
  fill: "#999"
}), React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: "0",
  y: "130",
  width: "500",
  height: "130",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d",
  x: "0",
  y: "0",
  width: "500",
  height: "130",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter2_d",
  x: "0",
  y: "260",
  width: "500",
  height: "130",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));